import { isObject } from "@/utils/isObject";

export function isReferenceObjectWithValue<T>(
  value: unknown
): value is ReferenceObject<T> {
  return (
    isObject(value) &&
    "@type" in value &&
    value["@type"] === "@builder.io/core:Reference" &&
    "value" in value
  );
}

export type ReferenceObject<T> = {
  "@type": "@builder.io/core:Reference";
  id: string;
  model: string;
  value: T;
};
